import { render, staticRenderFns } from "./LongitudinalLanding.vue?vue&type=template&id=289f6bb3&scoped=true"
import script from "./LongitudinalLanding.vue?vue&type=script&lang=js"
export * from "./LongitudinalLanding.vue?vue&type=script&lang=js"
import style0 from "./LongitudinalLanding.vue?vue&type=style&index=0&id=289f6bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f6bb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VList,VListItem,VMenu,VSpacer,VTextField})
